export { DocumentManagement as default } from './DocumentManagement';
